import { Switch } from "@/components/ui/switch";
import { useTran } from "@/hooks";

const OverviewViewModeToggle = ({ value, onChange }) => {
  const { t } = useTran();
  const isOn = value === "consolidated";
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm">
      <Switch
        checked={isOn}
        onCheckedChange={(next) => onChange(next ? "consolidated" : "flat")}
      />
      <span className="font-sm text-foreground">{t("Consolidated")}</span>
    </label>
  );
};

export default OverviewViewModeToggle;
